/*
 * @Author: Teemo Ding
 * @Date: 2021-10-14 14:41:07
 * @LastEditTime: 2021-10-15 14:59:11
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelSelection/config.tsx
 */
import css from './css.module.less';

export const columns = ({ getI18n }) => [
  {
    title: getI18n('general.salesChannelName'),
    dataIndex: 'name',
    key: 'name',
    default: true,
    optional: false,
    className: css.columnClass,
    width: 408,
  },
  {
    title: getI18n('general.salesChannelType'),
    dataIndex: 'channelType',
    default: true,
    optional: true,
    key: 'channelType',
    className: css.columnClass,
    minWidth: 140,
  },
];
